const burger = document.querySelector('header .burger') as HTMLElement;

const toggleNav = (): void => {
    document.body.classList.toggle('menu-open');
}

// mobile nav
burger.addEventListener('click', () => toggleNav());
